import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FaProjectDiagram,
  FaUsers,
  FaHandsHelping,
  FaClock,
} from "react-icons/fa";
import {
  Grid,
  Card,
  Text,
  useMantineTheme,
  Box,
  rem,
  Center,
  Space,
  NumberFormatter,
} from "@mantine/core";
import { Colors } from "../../lib/colors";

const stats = [
  {
    id: 1,
    label: "Years of Operation",
    value: 5,
    suffix: "+",
    icon: <FaClock size={48} color={Colors.statIcon} />,
  },
  {
    id: 2,
    label: "Projects Done",
    value: 60,
    suffix: "+",
    icon: <FaProjectDiagram size={48} color={Colors.statIcon} />,
  },
  {
    id: 3,
    label: "Projects Handed Over",
    value: 45,
    suffix: "+",
    icon: <FaHandsHelping size={48} color={Colors.statIcon} />,
  },
  {
    id: 4,
    label: "People Served",
    value: 20000,
    suffix: "+",
    icon: <FaUsers size={48} color={Colors.statIcon} />,
  },
];

const StatCard = ({ icon, value, suffix, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => (prev < value ? prev + Math.ceil(value / 50) : value));
    }, 30);
    return () => clearInterval(interval);
  }, [value]);

  return (
    <motion.div whileHover={{ scale: 1.05 }}>
      <Card bg={"#dbeafe"} shadow="sm" px="lg" py={"xl"} radius="md" >
        <Center>{icon}</Center>
        <Space h="lg" />
        <Text size={"32px"} fw={600} align="center">
          <NumberFormatter value={count} thousandSeparator="," />
          {suffix}
        </Text>
        <Text align="center" c="dimmed" size="lg">
          {label}
        </Text>
      </Card>
    </motion.div>
  );
};

export default function StatsSection() {
    const theme = useMantineTheme();

  return (
    <section id="statistics">
      <Box
        px={{ base: "md", md: rem(150) }}
        py={{ base: "50px", md: rem(150) }}
      >
        <Text ta={"center"} mb={"xs"} size="xl" tt="uppercase" fw={600}>
          Our impact in numbers
        </Text>
        <Space h={"50px"} />
        <Grid gutter="md">
          {stats.map((stat) => (
            <Grid.Col key={stat.id} span={{ base: 12, md: 6, lg: 3 }}>
              <StatCard {...stat} />
            </Grid.Col>
          ))}
        </Grid>
      </Box>
    </section>
  );
}
